import { GATEWAY_ORIGIN } from '@/constants/environment';

/**
 * DaVinci API Configuration
 *
 * Configuration constants for DaVinci REST API integration.
 * Login object required but empty (authentication handled by API Gateway).
 */

export const DAVINCI_CONFIG = {
  /**
   * API Gateway endpoint
   */
  ENDPOINT: `${GATEWAY_ORIGIN}/as`,

  /**
   * Booking configuration
   */
  AGENCY_NUMBER: 1,
  TOUROPERATOR: 'VAMOS',
  TRAVEL_TYPE: 'VR26',

  /**
   * Default nationality for participants — site is German-market only and the
   * UI has no nationality picker. Sent on every Participant.Passport.
   */
  DEFAULT_NATIONALITY: 'Deutschland',
  DEFAULT_NATIONALITY_CODE: 'DE',

  /**
   * Request timeout (milliseconds)
   */
  TIMEOUT: 30000, // 30 seconds

  /**
   * Retry configuration
   */
  RETRY: {
    maxAttempts: 3,
    initialDelay: 1000, // 1 second
  },
} as const;
